module.exports = __webpack_public_path__ + "static/media/health_screenint_bnner_image.0ace14ce.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/health_screenint_bnner_image.png
// module id = 1138
// module chunks = 0